import React, { Component } from 'react';
import styled from 'styled-components';
import feather from 'feather-icons';
import { repoToAction } from '../helpers';

export const icons = [
  'activity',
  'airplay',
  'alert-circle',
  'alert-octagon',
  'alert-triangle',
  'align-center',
  'align-justify',
  'align-left',
  'align-right',
  'anchor',
  'aperture',
  'archive',
  'arrow-down-circle',
  'arrow-down-left',
  'arrow-down-right',
  'arrow-down',
  'arrow-left-circle',
  'arrow-left',
  'arrow-right-circle',
  'arrow-right',
  'arrow-up-circle',
  'arrow-up-left',
  'arrow-up-right',
  'arrow-up',
  'at-sign',
  'award',
  'bar-chart-2',
  'bar-chart',
  'battery-charging',
  'battery',
  'bell-off',
  'bell',
  'bluetooth',
  'bold',
  'book-open',
  'book',
  'bookmark',
  'box',
  'briefcase',
  'calendar',
  'camera-off',
  'camera',
  'cast',
  'check-circle',
  'check-square',
  'check',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'chevrons-down',
  'chevrons-left',
  'chevrons-right',
  'chevrons-up',
  'circle',
  'clipboard',
  'clock',
  'cloud-drizzle',
  'cloud-lightning',
  'cloud-off',
  'cloud-rain',
  'cloud-snow',
  'cloud',
  'code',
  'command',
  'compass',
  'copy',
  'corner-down-left',
  'corner-down-right',
  'corner-left-down',
  'corner-left-up',
  'corner-right-down',
  'corner-right-up',
  'corner-up-left',
  'corner-up-right',
  'cpu',
  'credit-card',
  'crop',
  'crosshair',
  'database',
  'delete',
  'disc',
  'dollar-sign',
  'download-cloud',
  'download',
  'droplet',
  'edit-2',
  'edit-3',
  'edit',
  'external-link',
  'eye-off',
  'eye',
  'facebook',
  'fast-forward',
  'feather',
  'file-minus',
  'file-plus',
  'file-text',
  'file',
  'film',
  'filter',
  'flag',
  'folder-minus',
  'folder-plus',
  'folder',
  'gift',
  'git-branch',
  'git-commit',
  'git-merge',
  'git-pull-request',
  'globe',
  'grid',
  'hard-drive',
  'hash',
  'headphones',
  'heart',
  'help-circle',
  'home',
  'image',
  'inbox',
  'info',
  'italic',
  'layers',
  'layout',
  'life-buoy',
  'link-2',
  'link',
  'list',
  'loader',
  'lock',
  'log-in',
  'log-out',
  'mail',
  'map-pin',
  'map',
  'maximize-2',
  'maximize',
  'menu',
  'message-circle',
  'message-square',
  'mic-off',
  'mic',
  'minimize-2',
  'minimize',
  'minus-circle',
  'minus-square',
  'minus',
  'monitor',
  'moon',
  'more-horizontal',
  'more-vertical',
  'move',
  'music',
  'navigation-2',
  'navigation',
  'octagon',
  'package',
  'paperclip',
  'pause-circle',
  'pause',
  'percent',
  'phone-call',
  'phone-forwarded',
  'phone-incoming',
  'phone-missed',
  'phone-off',
  'phone-outgoing',
  'phone',
  'pie-chart',
  'play-circle',
  'play',
  'plus-circle',
  'plus-square',
  'plus',
  'pocket',
  'power',
  'printer',
  'radio',
  'refresh-ccw',
  'refresh-cw',
  'repeat',
  'rewind',
  'rotate-ccw',
  'rotate-cw',
  'rss',
  'save',
  'scissors',
  'search',
  'send',
  'server',
  'settings',
  'share-2',
  'share',
  'shield-off',
  'shield',
  'shopping-bag',
  'shopping-cart',
  'shuffle',
  'sidebar',
  'skip-back',
  'skip-forward',
  'slash',
  'sliders',
  'smartphone',
  'speaker',
  'square',
  'star',
  'stop-circle',
  'sun',
  'sunrise',
  'sunset',
  'tablet',
  'tag',
  'target',
  'terminal',
  'thermometer',
  'thumbs-down',
  'thumbs-up',
  'toggle-left',
  'toggle-right',
  'trash-2',
  'trash',
  'trending-down',
  'trending-up',
  'triangle',
  'truck',
  'tv',
  'type',
  'umbrella',
  'underline',
  'unlock',
  'upload-cloud',
  'upload',
  'user-check',
  'user-minus',
  'user-plus',
  'user-x',
  'user',
  'users',
  'video-off',
  'video',
  'voicemail',
  'volume-1',
  'volume-2',
  'volume-x',
  'volume',
  'watch',
  'wifi-off',
  'wifi',
  'wind',
  'x-circle',
  'x-square',
  'x',
  'zap-off',
  'zap',
  'zoom-in',
  'zoom-out',
];

export const colors = {
  'white': '#ffffff',
  'yellow': '#ffd33d',
  'blue': '#0366d6',
  'green': '#28a745',
  'orange': '#f66a0a',
  'red': '#d73a49',
  'purple': '#6f42c1',
  'gray-dark': '#24292e',
};

const Wrapper = styled.div`
  border: 1px solid #d1d5da;
  border-radius: 6px;
  background: white;
  width: 260px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: #f6f8fa;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom: 1px solid #d1d5da;
`;

const Description = styled.h5`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 1;
  margin-right: 5px;
  font-size: 14px;
`;

const Name = styled.h6`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 1;
  margin-right: 5px;
  font-size: 12px;
  color: #586069;
  margin: 0;
`;

const Icon = styled.div`
  background-color: ${props => colors[props.color]};
  box-shadow: rgba(27, 31, 35, 0.15) 0px 1px 5px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    color: ${props => determineSvgColor(props.color)};
    width: 28px;
    height: 28px;
  }
`;

const Body = styled.div`
  padding: 16px;
  border-bottom: 1px solid #d1d5da;
  font-size: 12px;
  font-weight: 500;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  span:first-child {
    padding-right: 16px;
    color: #586069;
  }

  span:last-child {
    color: black;
  }
`;

const Footer = styled.div`
  padding: 8px 16px;
  font-size: 12px;
  display: flex;
  flex-direction: column;

  button {
    align-self: flex-end;
    color: #0366d6;
    background: none;
    border: none;
    margin: 0;
    padding: 0;

    &:hover {
      text-decoration: underline;
    }
  }
`;

function determineSvgColor(bg) {
  return (bg === 'yellow' || bg === 'white') ? 'black' : 'white';
}

class Action extends Component {
  render() {
    const { name, color, icon, repo } = this.props;
    return (
      <Wrapper>
        <Header>
          <div>
            <Description>Sample Action</Description>
            <Name>{name}</Name>
          </div>
          <Icon
            color={color}
            dangerouslySetInnerHTML={{
              __html: feather.icons[icon].toSvg()
            }}
          />
        </Header>
        <Body>
          <span>uses</span>
          <span>{repoToAction(repo)}</span>
        </Body>
        <Footer>
          <button disabled>Edit</button>
        </Footer>
      </Wrapper>
    );
  }
}

export default Action;
